import React, { useEffect, useState, Component } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { ClientLogos } from './components/ClientLogos';
import { MeetIrina } from './components/MeetIrina';
import { WhyGigi } from './components/WhyGigi';
import { HowItWorks } from './components/HowItWorks';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { BetaSignup } from './components/BetaSignup';
import { TermsOfService } from './components/TermsOfService';
import { ContactUs } from './components/ContactUs';
import { DashboardLayout } from './components/dashboard/DashboardLayout';
import { AuthPage } from './components/auth/AuthPage';
import { PartnershipsPage } from './components/PartnershipsPage';
import { PitchDeck } from './components/PitchDeck';
import { InvestorLandingPage } from './components/investor/InvestorLandingPage';
import { initGA, trackPageView } from './utils/analytics';
const LandingPage = ({
  onJoinBeta,
  isBetaModalOpen,
  onCloseBeta,
  currentPage,
  setCurrentPage
}) => {
  if (currentPage === 'terms') {
    return <div className="min-h-screen bg-white" data-id="element-0">
        <Navbar onJoinBeta={onJoinBeta} showBackButton onBackClick={() => setCurrentPage('home')} data-id="element-1" />
        <TermsOfService data-id="element-2" />
        <Footer onTermsClick={() => setCurrentPage('terms')} onContactClick={() => setCurrentPage('contact')} data-id="element-3" />
        <BetaSignup isOpen={isBetaModalOpen} onClose={onCloseBeta} data-id="element-4" />
      </div>;
  }
  if (currentPage === 'contact') {
    return <div className="min-h-screen bg-white" data-id="element-5">
        <Navbar onJoinBeta={onJoinBeta} showBackButton onBackClick={() => setCurrentPage('home')} data-id="element-6" />
        <ContactUs data-id="element-7" />
        <Footer onTermsClick={() => setCurrentPage('terms')} onContactClick={() => setCurrentPage('contact')} data-id="element-8" />
        <BetaSignup isOpen={isBetaModalOpen} onClose={onCloseBeta} data-id="element-9" />
      </div>;
  }
  return <div className="min-h-screen bg-white" data-id="element-10">
      <Navbar onJoinBeta={onJoinBeta} data-id="element-11" />
      <main data-id="element-12">
        <Hero onJoinBeta={onJoinBeta} data-id="element-13" />
        <MeetIrina data-id="element-14" />
        <WhyGigi data-id="element-15" />
        <HowItWorks data-id="element-16" />
        <ClientLogos data-id="element-17" />
        <FAQ data-id="element-18" />
      </main>
      <Footer onTermsClick={() => setCurrentPage('terms')} onContactClick={() => setCurrentPage('contact')} data-id="element-19" />
      <BetaSignup isOpen={isBetaModalOpen} onClose={onCloseBeta} data-id="element-20" />
    </div>;
};
// Component to track route changes
const RouteTracker = () => {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);
  return null;
};
export function App() {
  const [isBetaModalOpen, setIsBetaModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState('home');
  // Initialize Google Analytics on mount
  useEffect(() => {
    initGA();
  }, []);
  return <BrowserRouter data-id="element-21">
      <RouteTracker data-id="element-22" />
      <Routes data-id="element-23">
        <Route path="/" element={<LandingPage onJoinBeta={() => setIsBetaModalOpen(true)} isBetaModalOpen={isBetaModalOpen} onCloseBeta={() => setIsBetaModalOpen(false)} currentPage={currentPage} setCurrentPage={setCurrentPage} data-id="element-25" />} data-id="element-24" />
        <Route path="/auth" element={<AuthPage data-id="element-27" />} data-id="element-26" />
        <Route path="/partnerships" element={<PartnershipsPage data-id="element-29" />} data-id="element-28" />
        <Route path="/deck" element={<PitchDeck data-id="element-31" />} data-id="element-30" />
        <Route path="/investors" element={<InvestorLandingPage data-id="element-33" />} data-id="element-32" />
        <Route path="/dashboard/*" element={<DashboardLayout data-id="element-35">
              <div className="text-2xl font-bold" data-id="element-36">
                Welcome to your Dashboard!
              </div>
            </DashboardLayout>} data-id="element-34" />
      </Routes>
    </BrowserRouter>;
}